import React from 'react';
import { Outlet } from 'react-router-dom';
import { useScrollToTop } from '../hooks/useScrollToTop';

const CleanLayout: React.FC = () => {
  // Use the scroll to top hook to ensure pages start at the top
  useScrollToTop();
  
  return <Outlet />;
};

export default CleanLayout; 